import React from 'react';
import PropTypes from 'prop-types';
import styled from "@emotion/styled";
import Label1 from "../common/Label1";
import LinkTableCellComponent from "../common/LinkTableCellComponent";
import {IconButton, Icon} from "@material-ui/core";
import {getDurationInMonth} from "../../utils";
import ContractStatus from "../common/ContractStatus";
import {currencyFormatter} from "../../utils/formatter";

const PageWrapper = styled.div`
  width: max-content;
  height: min-content;
  display:grid;
  grid-auto-flow: column;
  grid-column-gap: 60px;
  flex-direction: row;
  justify-content: space-evenly;
  
  //> * {
  //  margin-right: 60px;
  //}
`;

const ContractInfo = styled.div`
    display: grid;
    grid-auto-flow: row;
    grid-template-columns: repeat(3, max-content);
    grid-column-gap: 32px;
    
    > div {
        display: grid;
        grid-template-rows: 1fr 1fr;
        grid-row-gap: 10px;    
    }
`;

const ContractHeading = styled.div`
    width: 200px;
    display: grid;
    grid-template-rows: 1fr 1fr;
    grid-row-gap: 10px;    
`;


function ContractLineItem({contractId, status, startDate, endDate, monthlyPayment, totalCashPrice, onMoreBtnClick, onContractIdClick}) {
    return (
        <PageWrapper >
            <ContractHeading>
                <div>Contract ID: <LinkTableCellComponent name={contractId} onLinkClick={onContractIdClick}/> </div>
                <div style={{
                    display: "flex",
                    flexDirection: "row"
                }}>
                    <span style={{marginRight:"10px"}} >Status: </span> <ContractStatus status={status}/>
                </div>
            </ContractHeading>

            <ContractInfo>
                <div>
                    <Label1>
                        Plan Duration
                    </Label1>

                    <div>
                        {getDurationInMonth(startDate, endDate)}
                    </div>
                </div>

                <div>
                    <Label1>
                        Monthly Payment
                    </Label1>

                    <div>
                        ${currencyFormatter(monthlyPayment)}
                    </div>
                </div>

                <div>
                    <Label1>
                        Total Cash Price
                    </Label1>

                    <div>
                        ${currencyFormatter(totalCashPrice)}
                    </div>
                </div>
            </ContractInfo>

            <div>
                <IconButton onClick={onMoreBtnClick}>
                    <Icon fontSize="large">more_vert</Icon>
                </IconButton>
            </div>
        </PageWrapper>
    );
}

ContractLineItem.propTypes = {
    contractId: PropTypes.string,
    status: PropTypes.string,
    planDuration: PropTypes.string,
    monthlyPayment: PropTypes.string,
    totalCashPrice: PropTypes.string,
    onMoreBtnClick: PropTypes.func,
    onContractIdClick: PropTypes.func
};
ContractLineItem.defaultProps = {};

export default ContractLineItem;
